import { createSelector } from 'reselect';
import { SelectedOrderState, OrderListState, CancelOrderState } from './types';
import { AppState } from '../../types';

export const selectOrderList = (state: AppState): OrderListState => state.orders.list;

export const selectOrder = (state: AppState): SelectedOrderState => state.orders.selected;

export const selectCancelOrder = (state: AppState): CancelOrderState => state.orders.cancel;

export const isOrderPersistent = createSelector(
  selectOrder,
  (state) => Boolean(state.data?.id),
);
